import qs from 'qs';
import instance from '../axios';

export const getDrivers = () => {
  return instance.get('/users/drivers');
};
